import { Factura } from './../../entities/factura.entity';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BaseChartDirective } from 'ng2-charts';
import { SessionService } from '../../services/session.service';
import { data } from 'jquery';

@Component({
  selector: 'app-bar-chart-demo',
  templateUrl: './grafico.component.html'
})
export class GraficoComponent implements OnInit {
  @ViewChild(BaseChartDirective)
  public static UpdateData: Subject<Factura[]> = new Subject();
  public chart: BaseChartDirective;
  public barChartLabels: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartDataData: number[] = [];
  public barChartData: any[] = [{ data: [], label: '' }];
  public colorCampos: string[];
  public lineChartColors = [{ backgroundColor: [] }];
  public barChartOptions: any = {
    scaleShowVerticalLines: false, responsive: true
  };
  @Input() grafica: Factura[];

  constructor(private sessionService: SessionService) {
    this.barChartLabels = [];
    this.barChartData = undefined;
    GraficoComponent.UpdateData.subscribe(res => {
      this.CargarDatos(res);
    });
  }

  ngOnInit() {
    this.barChartLabels = [];
    this.barChartData = undefined;
    if (this.grafica !== undefined) {
      this.CargarDatos(this.grafica);
    }
  }

  public CargarDatos(datos: Factura[]) {
    // 'rgb(248,0,0)' - Red | 'rgb(0,44,88)' - Prussian Blue | 'rgb(0,175,210)' - Cerulean
    const BAR_COLORS: string[] = ['rgb(248,0,0)', 'rgb(0,44,88)', 'rgb(0,175,210)'];
    this.barChartLabels = [];
    this.barChartLabels.length = 0;
    this.barChartDataData = [];
    this.barChartData = undefined;
    const dataLength = (datos.length > 6) ? 6 : datos.length;
    const newData = datos.slice(0, dataLength);
    if (this.sessionService.datosExplotacion.Codigo.toUpperCase() === 'MELILLA') {
      newData.forEach((factura, i) => {
        this.barChartLabels.push(factura.Periodo.Descripcion);
        this.barChartDataData.push(factura.ConsumoFactura);
        if ((i + 1) % 2 === 0) {
          this.lineChartColors[0].backgroundColor[i] = BAR_COLORS[1];
        } else {
          this.lineChartColors[0].backgroundColor[i] = BAR_COLORS[2];
        }
      });
    } else {
      newData.forEach((factura, i) => {
        this.barChartLabels.push(factura.Periodo.Descripcion);
        this.barChartDataData.push(factura.ConsumoFactura);
        if (factura.TotalCobrado < factura.TotalFacturado) {
          this.lineChartColors[0].backgroundColor[i] = BAR_COLORS[0];
        } else if ((i + 1) % 2 === 0) {
          this.lineChartColors[0].backgroundColor[i] = BAR_COLORS[1];
        } else {
          this.lineChartColors[0].backgroundColor[i] = BAR_COLORS[2];
        }
      });
    }
    this.barChartData = [{ data: this.barChartDataData, label: 'Consumo m3' }];
  }

  // events
  public chartClicked(e: any): void { }

  public chartHovered(e: any): void { }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/grafico.component.ts